import {
  ConnectRequired,
  DialogForm,
  Input,
  Label,
} from "@gearbox-protocol/ui-kit";
import { useState } from "react";
import { toast } from "sonner";
import { Hex } from "viem";
import { useAddAudit } from "@/hooks/use-bytecode-add-audit";

interface AddAuditDialogProps {
  onClose: () => void;
  bytecodeHash: Hex;
}

export function AddAuditDialog({ onClose, bytecodeHash }: AddAuditDialogProps) {
  const [reportUrl, setReportUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onSuccess = () => {
    onClose();
    setReportUrl("");
    setIsLoading(false);
  };

  const { sign } = useAddAudit({ onSuccess });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await sign(bytecodeHash, reportUrl);
      toast.success("Audit added successfully");
    } catch (error) {
      setIsLoading(false);
      console.error("Error adding audit:", error);
      toast.error("Error adding audit");
    }
  };

  return (
    <DialogForm
      title="Add Audit"
      onCancel={onClose}
      onSubmit={handleSubmit}
      isFormValid={reportUrl.length > 0}
      saveButtonText="Add Audit"
      isLoading={isLoading}
      submitButtonVariant="pink"
      authWrapper={ConnectRequired}
    >
      <div>
        <Label htmlFor="reportUrl">Report URL</Label>
        <Input
          id="reportUrl"
          value={reportUrl}
          onChange={e => setReportUrl(e.target.value)}
          required
        />
      </div>
    </DialogForm>
  );
}
